<template>
    <AppFormValidator
        ref="validator"
        #default="{ errors }"
        :model="model"
        :rules="rules">
        <CForm>
            <CInput
                v-if="adminOnly"
                v-model="model.title"
                label="Название"
                placeholder="Введите название"
                :is-valid="errors.title && errors.title.isValid" />

            <CInput
                v-if="adminOnly"
                v-model="model.code"
                label="Код"
                placeholder="Введите код"
                :is-valid="errors.code && errors.code.isValid" />
            <CInput v-model="computedCode" type="hidden" />

            <div
                v-if="adminOnly" 
                class="flex items-center mb-2">
                <div class="flex items-center w-1/2">
                    <div class="col-form-label">Алкоголь</div>

                    <CSwitch
                        class="ml-4"
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.is_alcohol" />
                </div>
            </div>

            <div
                v-if="adminOnly" 
                class="flex items-center mb-2">
                <div class="flex items-center w-1/2">
                    <div class="col-form-label">Программа лояльности</div>

                    <CSwitch
                        class="ml-4"
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.loyalty" />
                </div>
            </div>

            <CInput
                v-if="adminOnly"
                v-model="model.legal_entity"
                label="Юр. лицо"
                placeholder="ООО…" />

            <CInput
                v-if="adminOnly"
                v-model="model.short_title"
                label="Короткое название"
                placeholder="Введите короткое название"
                :is-valid="errors.short_title && errors.short_title.isValid" />

            <CTextarea
                v-if="adminOnly"
                v-model="model.description"
                label="Краткое описание"
                placeholder="Укажите краткое описание (не более 255 символов)"
                :is-valid="errors.description && errors.description.isValid" />

            <CTextarea
                v-if="adminOnly"
                v-model="model.synonyms"
                label="Синонимы"
                placeholder="Укажите синонимы для поиска" />

            <CInput
                v-if="!model.id && adminOnly"
                v-model="model.phone"
                label="Телефон"
                :is-valid="errors.phone && errors.phone.isValid" />

            <div
                v-if="!model.id && adminOnly" 
                class="flex items-center">
                <div class="w-1/2">
                    Изображение для декстопа (внутри сервиса)
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="model.desktop_picture ? model.desktop_picture : 'Выберите изображение'"
                        @change="uploadDesktopPicture" />
                </div>
                <div class="mx-4"></div>
                <div class="w-1/2">
                    Изображение для декстопа (список)
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="model.desktop_picture_list ? model.desktop_picture_list : 'Выберите изображение'"
                        @change="uploadDesktopPictureInList" />
                </div>
                <div class="mx-4"></div>
                <div class="w-1/2">
                Изображение сервиса (мобильное приложение)
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="model.picture ? model.picture : 'Выберите изображение'"
                        :is-valid="errors.picture && errors.picture.isValid"
                        @change="uploadPicture" />
                </div>
                <div class="mx-4"></div>
                <div class="w-1/2">
                    Изображение для поиска
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="model.square_picture ? model.square_picture : 'Выберите изображение для поиска'"
                        :is-valid="errors.square_picture && errors.square_picture.isValid"
                        @change="uploadSquarePicture" />
                </div>
                <div class="mx-4"></div>
                <div class="w-1/2">
                    Изображение для популярного
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="model.popular_picture ? model.popular_picture : 'Выберите изображение для популярного'"
                        :is-valid="errors.popular_picture && errors.popular_picture.isValid"
                        @change="uploadPopularPicture" />
                </div>
                <div class="mx-4"></div>
            </div>

            <CInput
                v-if="adminOnly"
                v-model="model.data_url"
                label="Ссылка YML каталога"
                :is-valid="errors.data_url && errors.data_url.isValid" />

            <CInput
                v-if="adminOnly"
                v-model="model.alias"
                label="Алиас"
                :is-valid="errors.alias && errors.alias.isValid" />

            <CSelect
                v-if="adminOnly"
                class="mb-3"
                label="Башня"
                placeholder="Башня..."
                :options="towers"
                :value.sync="model.tower"
            />

            <div
                v-if="adminOnly" 
                class="flex items-center">
                <CInput
                    v-model.number="model.weight_limit"
                    class="w-1/2"
                    label="Ограничение по весу (грамм)" />
                <div class="mx-4"></div>
            </div>

            <div v-if="model.weight_limit && model.weight_limit > 0 && adminOnly" class="flex items-center">
                <CInput
                    v-model="model.weight_limit_description"
                    class="w-1/2"
                    label="Сообщение о превышении веса" />
                <div class="mx-4"></div>
            </div>
            <div v-if="adminOnly" class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                <CRow>
                    <CCol tag="label" class="col-form-label">
                        <b>Лейблы</b>
                    </CCol>
                </CRow>
                <CRow 
                    v-if="adminOnly">
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">
                        Новый сервис
                    </CCol>
                    <CCol>
                        <CSwitch
                            color="dark"
                            shape="pill"
                            variant="opposite"
                            :checked.sync="model.is_new_label" 
                        />
                    </CCol>
                </CRow>
                <CRow 
                    v-if="adminOnly">
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">
                        Веган
                    </CCol>
                    <CCol>
                        <CSwitch
                            color="dark"
                            shape="pill"
                            variant="opposite"
                            :checked.sync="model.vegan_label" 
                        />
                    </CCol>
                </CRow>
                <CRow 
                    v-if="adminOnly">
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">
                        Проверено МИРСИТИ
                    </CCol>
                    <CCol>
                        <CSwitch
                            color="dark"
                            shape="pill"
                            variant="opposite"
                            :checked.sync="model.verified_mircity_label" 
                        />
                    </CCol>
                </CRow>
            </div>
            <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                <WorkingHours 
                    :working-hours="workingHours"
                    :service-type="'grocer'"
                    @working-hours-update="fetch"
                />
                <CRow v-if="adminOnly">
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">
                        Скрывать когда закрыт
                    </CCol>
                    <CCol sm="9">
                        <CSwitch
                            color="dark"
                            shape="pill"
                            variant="opposite"
                            :checked.sync="model.hide"
                        />
                    </CCol>
                </CRow>
            </div>
            
            <CRow v-if="adminOnly">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">
                    Страница категорий
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.categories_page"
                    />
                </CCol>
            </CRow>

            <CRow v-if="adminOnly">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">
                    Показывать статус постоплаты
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.status_postpay"
                    />
                </CCol>
            </CRow>

            <!-- show_main_page -->

            <CRow v-if="adminOnly">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">
                    Показывать на главной странице
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.show_main_page"
                    />
                </CCol>
            </CRow>


            <CRow v-if="adminOnly">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">
                    Убрать применение промокода
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.hide_promocode"
                    />
                </CCol>
            </CRow>

            <CRow v-if="adminOnly">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">
                    Предзаказ
                </CCol>
                <CCol sm="9">
                    <CSelect
                        label=""
                        :options="preorderOptions"
                        :value.sync="model.hide_preorder"
                    />
                </CCol>
            </CRow>

            <div
                v-if="!model.id && adminOnly"  
                class="flex items-center">
                <CInput
                    v-model="model.delay_time_hour"
                    class="w-1/2"
                    label="Время, необходимое на выполнение заказа (часы)"
                    :is-valid="errors.delay_time_hour && errors.delay_time_hour.isValid" />
                <div class="mx-4"></div>
                <CInput
                    v-model="model.delay_time"
                    class="w-1/2"
                    label="Время, необходимое на выполнение заказа (минуты)"
                    :is-valid="errors.delay_time && errors.delay_time.isValid" />
            </div>
            <div
                v-if="!model.id && adminOnly"  
                class="flex items-center">
                <CInput
                    v-model="model.delivery_time_hour"
                    class="w-1/2"
                    label="Время доставки (часы)"
                    :is-valid="errors.delivery_time_hour && errors.delivery_time_hour.isValid" />
                <div class="mx-4"></div>
                <CInput
                    v-model="model.delivery_time"
                    class="w-1/2"
                    label="Время доставки (минуты)"
                    :is-valid="errors.delivery_time && errors.delivery_time.isValid" />
            </div>
            <div
                v-if="!model.id && adminOnly"  
                class="flex items-center">
                <CInput
                    v-model="model.max_delivery_time_hour"
                    class="w-1/2"
                    label="Максимальное время доставки (часы)"
                    placeholder="Часы"
                />
                <div class="mx-4"></div>
                <CInput
                    v-model="model.max_delivery_time"
                    class="w-1/2"
                    label="Максимальное время доставки (минуты)"
                    placeholder="Минуты"
                />
            </div>

            <div
                v-if="!model.id && adminOnly" 
                class="flex items-center">
                <CInput
                    v-model="model.open_at"
                    class="w-1/2"
                    label="Открывается в" />
                <div class="mx-4"></div>
                <CInput
                    v-model="model.close_at"
                    class="w-1/2"
                    label="Закрывается в" />
            </div>
            <CRow v-if="adminOnly">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">
                    Отключить применение тарифов по зонам
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.delivery_zone_disabled" 
                    />
                </CCol>
            </CRow>
            <div
                v-if="adminOnly"
                class="flex items-center">
                <div class="flex items-center w-1/2">
                    <div class="col-form-label">Активен</div>
                    <CSwitch
                        class="ml-4"
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.enabled" />
                </div>
                <div class="flex items-center w-1/2">
                    <div class="col-form-label">Архив</div>
                    <CSwitch
                        class="ml-4"
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.archive" />
                </div>
            </div>
        </CForm>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="disabledModal"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Отключение сервиса по причине: <br> <strong>"указать причину"</strong> до <strong>"указать дату"</strong>.
                    </p>
                    <br>
                    <div>
                        <label>Причина отключения сервиса:</label>
                        <CInput
                            v-model="model.why_is_it_off"
                            placeholder="Причина отключения"
                        />
                    </div>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="disabledModal = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="saveDisabledService">Сохранить</CButton>
                </div>
            </template>
        </CModal>

        <div class="flex mt-4">
            <CButton color="primary" @click="submit">{{ submitButtonTitle }}</CButton>

            <CButton
                v-if="model.id && adminOnly"
                variant="outline"
                color="danger"
                class="ml-4"
                @click="promptDelete">Удалить</CButton>
        </div>

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить запись? Это действие нельзя будет отменить."
            @confirm="confirmDelete" />
    </AppFormValidator>
</template>

<script>
    import to from 'await-to-js';
    import { morphism } from 'morphism';
    import { requiredRule, xssRegEx } from '@/utils/rules';
    import { BUSINESS_LABEL } from '@/utils/servicesLabel'
    import { BUSINESS_TYPE } from '@/utils/order'

    import AppFormValidator from '@/components/AppFormValidator';
    import AppConfirmDialog from '@/components/AppConfirmDialog';
    import TimeSlotsUpdate from '@/components/TimeSlotsUpdate';
    import WorkingHours from '@/components/WorkingHoursUpdate';
    import { translit } from '@/utils/translit';
    import moment from 'moment';

    export default {
        components: {
            AppFormValidator,
            AppConfirmDialog,
            TimeSlotsUpdate,
            WorkingHours
        },

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data: () => ({
            disabledModal: false,
            activityСheck: false,
            isPending: false,
            schedule: undefined,
            timeSlots: undefined,
            model: {},
            workingHours: [],
            BUSINESS_TYPE,
            enabledOnServer: false,
            schema: {
                id: 'id',
                code: 'code',
                legal_entity: 'legal_entity',
                title: 'title',
                short_title: 'short_title',
                description: 'description',
                synonyms: 'synonyms',
                address: 'address',
                picture: 'picture',
                square_picture: 'square_picture',
                delivery_picture: 'delivery_picture',
                desktop_picture: 'desktop_picture',
                desktop_picture_list: 'desktop_picture_list',
                popular_picture: 'popular_picture',
                tower: 'tower',
                open_at: null,
                close_at: null,
                extended_schedule: 'extended_schedule',
                categories_page: 'categories_page',
                status_postpay: 'status_postpay',
                hide_promocode: 'hide_promocode',
                hide_preorder: 'hide_preorder',
                show_main_page: 'show_main_page',
                phone: 'phone',
                data_url: 'data_url',
                alias: 'alias',
                max_delivery_time_hour: 'max_delivery_time_hour',
                max_delivery_time: 'max_delivery_time',
                weight_limit: 'weight_limit',
                weight_limit_description: 'weight_limit_description',
                service_label: 'service_label',
                verified_mircity_label: 'verified_mircity_label',
                vegan_label: 'vegan_label',
                is_new_label: 'is_new_label',
                is_alcohol: 'is_alcohol',
                loyalty: 'loyalty',
                hide: 'hide',

                why_is_it_off: 'why_is_it_off',
                who_turned_off: 'who_turned_off',
                shutdown_date: 'shutdown_date',
                position: source => (source.position ? source.position : 1),
                delivery_zone_disabled: source => !!source.delivery_zone_disabled,
                enabled: source => typeof source.enabled === 'boolean' ? source.enabled : false,
                archive: source => typeof source.archive === 'boolean' ? source.archive : false,
                delay_time_hour: source =>
                    typeof source.delay_time_hour === 'number'
                        ? source.delay_time_hour.toString()
                        : undefined,
                delay_time: source =>
                    typeof source.delay_time === 'number'
                        ? source.delay_time.toString()
                        : undefined,
                delivery_time_hour: source =>
                    typeof source.delivery_time_hour === 'number'
                        ? source.delivery_time_hour.toString()
                        : undefined,
                delivery_time: source =>
                    typeof source.delivery_time === 'number'
                        ? source.delivery_time.toString()
                        : undefined,
            },
            rules: {
                title: [requiredRule],
                code: [requiredRule],
                picture: [requiredRule],
                description: [requiredRule],
                phone: [requiredRule],
                delay_time: [
                    {
                        type: 'string',
                        pattern: /^[0-9]*$/,
                        message: 'Укажите в цифрах',
                    },
                ],
                delay_time_hour: [
                    {
                        type: 'string',
                        pattern: /^[0-9]*$/,
                        message: 'Укажите в цифрах',
                    },
                ],
                delivery_time: [
                    {
                        type: 'string',
                        pattern: /^[0-9]*$/,
                        message: 'Укажите в цифрах',
                    },
                ],
                delivery_time_hour: [
                    {
                        type: 'string',
                        pattern: /^[0-9]*$/,
                        message: 'Укажите в цифрах',
                    },
                ],
                min_price: [
                    {
                        type: 'string',
                        pattern: /^[1-9]{1}[0-9]*$/,
                        message: 'Укажите в цифрах или оставьте поле пустым',
                    },
                ],
            },
            towers: [],
            preorderOptions: [
                { value: 0, label: 'Разрешен предзаказ' },
                { value: 1, label: 'Разрешен предзаказ только на сегодня' },
                { value: 2, label: 'Предзаказ запрещен' }
            ],
        }),
        
        computed: {
            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
            computedCode() {
                if (!this.entity.code) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.model.code = translit(
                        this.model.title ? this.model.title : ''
                    );
                }
                return this.model.code;
            },
        },

        created() {
            this.setModel();
        },

        async mounted() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = this.$route.params.id;
                this.axios
                    .get(`/grocers/${id}`)
                    .then(resp => {
                        this.enabledOnServer = resp.data?.enabled;
                        this.allowedSave = false;
                        this.activityСheck = false;
                        if(resp.data?.timeSlots?.length != 0) {
                            this.timeSlots = resp.data.timeSlots;
                        }
                        if(resp.data?.workingHours?.length != 0) {
                            this.workingHours = resp.data.workingHours;
                        }
                    })
                    .catch(err => {
                        console.log('Ошибка загрузки данных');
                    });

                if (!this.towers.length) {
                    const towers = [{ value: null, label: 'Башня...' }];
                    this.axios
                        .get('/address')
                        .then(({ data }) => {
                            data.forEach(tower => {
                                towers.push({ value: tower.id, label: tower.name });
                            });
                        });
                    this.towers = towers;
                }
            },
            setSchedule(schedule) {
                this.schedule = schedule;
            },

            setTimeSlots(timeSlots) {
                this.timeSlots = timeSlots;
            },
            setModel() {
                this.model = morphism(this.schema, this.entity);
                if (!this.entity.schedule) {
                    this.entity.schedule = [];
                }
                this.setSchedule(this.entity.schedule);
                
                if (!this.entity.timeSlots) {
                    this.entity.timeSlots = [];
                }
                this.setTimeSlots(this.entity.timeSlots);
                
                // Ensure hide property is initialized
                if (!this.model.hide) {
                    this.model.hide = false;
                }
                
                // Ensure hide_preorder property is initialized as integer
                if (!this.model.hide_preorder) {
                    this.model.hide_preorder = 0;
                }
            },

            async uploadPicture(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(
                    this.axios.post('/files/upload', form)
                );

                if (err) {
                    this.$root.$emit('showError', 'Ошибка. Не удалось загрузить картинку. ' + err);
                }

                this.model.picture = result.data.filename;
            },
            async uploadDesktopPicture(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(
                    this.axios.post('/files/upload', form)
                );

                if (err) {
                    this.$root.$emit('showError', 'Ошибка. Не удалось загрузить картинку. ' + err);
                }

                this.model.desktop_picture = result.data.filename;
            },
            async uploadDesktopPictureInList(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(
                    this.axios.post('/files/upload', form)
                );

                if (err) {
                    alert('Ошибка. Не удалось загрузить картинку.');
                }

                this.model.desktop_picture_list = result.data.filename;
            },

            async uploadPopularPicture(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(
                    this.axios.post('/files/upload', form)
                );

                if (err) {
                    alert('Ошибка. Не удалось загрузить картинку.');
                }

                this.model.popular_picture = result.data.filename;
            },
            async submit() {
                const [error] = await to(this.$refs.validator.validate());

                if (error) {
                    return false;
                }

                const { id, ...payload } = this.model;

                if (this.enabledOnServer && !this.model.enabled && !this.allowedSave) {
                    this.disabledModal = true;
                    return;
                }

                payload.extended_schedule = !!payload.extended_schedule;
                payload.categories_page = !!payload.categories_page;
                payload.status_postpay = !!payload.status_postpay;
                payload.hide_promocode = !!payload.hide_promocode;
                payload.show_main_page = !!payload.show_main_page;
                payload.is_new_label = !!payload.is_new_label;
                payload.vegan_label = !!payload.vegan_label;
                payload.is_alcohol = !!payload.is_alcohol;
                payload.loyalty = !!payload.loyalty;
                payload.verified_mircity_label = !!payload.verified_mircity_label;
                payload.hide = !!payload.hide;
                payload.position = parseInt(payload.position);
                payload.schedule = this.schedule;
                payload.max_delivery_time = +payload.max_delivery_time ? +payload.max_delivery_time : null;
                payload.max_delivery_time_hour = +payload.max_delivery_time_hour ? +payload.max_delivery_time_hour : null;
                payload.data_url = payload.data_url ? payload.data_url : '';
                payload.weight_limit = +payload.weight_limit ? +payload.weight_limit : null;
                payload.why_is_it_off = this.enabledOnServer && !this.model.enabled && payload.why_is_it_off ? "" + payload.why_is_it_off : null;
                if (!payload.open_at) {
                    payload.open_at = '0';
                }
                if (!payload.close_at) {
                    payload.close_at = '0';
                }
                payload.delay_time = payload.delay_time
                    ? parseInt(payload.delay_time)
                    : 0;
                payload.delay_time_hour = payload.delay_time_hour
                    ? parseInt(payload.delay_time_hour)
                    : 0;
                payload.delivery_time = payload.delivery_time
                    ? parseInt(payload.delivery_time)
                    : 0;
                payload.delivery_time_hour = payload.delivery_time_hour
                    ? parseInt(payload.delivery_time_hour)
                    : 0;
                if (typeof id === 'number') {
                    const [err] = await to(
                        this.axios.put(`/grocers/${id}`, payload)
                    );
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось сохранить запись. ' + err);
                    }
                } else {
                    const [err] = await to(this.axios.post('/grocers', payload));
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось создать новую запись. ' + err);
                    }
                }

                this.$emit('success');
            },

            
            async saveDisabledService() {
                if (!this.model.why_is_it_off && !this.model.enabled) {
                    alert('Укажите причину отключения');
                    return;
                }
                this.allowedSave = true;

                await this.submit();
            },


            promptDelete() {
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.model.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(`/grocers/${this.model.id}`)
                );

                if (error) {
                    this.$root.$emit('showError', 'Ошибка удаления. ' + error);
                }

                this.$emit('deleted');
            },
        },
    };
</script>
